import { render } from "./statistics.vue?vue&type=template&id=51966332"
const script = {}

import "./statistics.vue?vue&type=style&index=0&id=51966332&lang=scss"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__